/**
 * The name of a country in the given language (`Intl.DisplayNames`), e.g. `('es', 'de')` → "Spanien".
 * Falls back to `fallback` when there's no locale or the browser doesn't know the code.
 */
export function getCountryName(iso2: string, locale: string | undefined, fallback: string): string {
    if (!locale) {
        return fallback;
    }

    try {
        return new Intl.DisplayNames([locale], { type: 'region' }).of(iso2.toUpperCase()) ?? fallback;
    } catch {
        return fallback;
    }
}
